import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { useLayoutEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getIdWithPrefix } from 'utils/pathUtils'
import { NewUnmatchedCompanyPage } from '../new-company-pages/NewUnmatchedCompanyPage'

export function CompanyPage() {
  const params = useParams()
  const prefix = params?.company_id ? params.company_id.slice(0, 2) : undefined
  const { preferences } = usePreferences()
  const [loaded, setLoaded] = useState(false)

  useLayoutEffect(() => {
    // based on prefix, redirect to the correct page
    // COMPANY TYPE UPDATE
    switch (prefix) {
      case preferences?.company_type_prefix_map[ContactCompanyType.Chain]:
        window.location.href = `/chain/${params?.company_id}`
        return
      case preferences?.company_type_prefix_map[ContactCompanyType.University]:
        window.location.href = `/university/${params?.company_id}`
        return
      case preferences?.company_type_prefix_map[ContactCompanyType.K12District]:
        window.location.href = `/k12/${params?.company_id}`
        return
      case preferences?.company_type_prefix_map[ContactCompanyType.Hospital]:
        window.location.href = `/hospital/${params?.company_id}`
        return
      case preferences?.company_type_prefix_map[ContactCompanyType.NursingHome]:
        window.location.href = `/nursinghome/${params?.company_id}`
        return
      case preferences?.company_type_prefix_map[ContactCompanyType.Lodging]:
        window.location.href = `/lodging/chain/${params?.company_id}`
        return
      case preferences?.company_type_prefix_map[ContactCompanyType.Convenience]:
        window.location.href = `/convenience/chain/${params?.company_id}`
        return
    }

    setLoaded(true)
  }, [params?.company_id])

  if (!loaded) return null

  const companyID = getIdWithPrefix(
    params.company_id as string,
    preferences?.company_type_prefix_map[ContactCompanyType.UserGenerated]
  ) as number

  return <NewUnmatchedCompanyPage companyID={companyID} />
}
